export const IDENTITY = {
  name: "Aditi Gajbhiye",
  title: "Digital Marketing Specialist",
  location: "Pune, India",
  timezone: "Asia/Kolkata",
  email: "aditigaj99@gmail.com",
  linkedin: "https://www.linkedin.com/in/aditigajbhiye/",
  resumeUrl: "/Aditi-Gajbhiye-Resume.pdf",
  heroPhoto:
    "https://customer-assets-jai6qajn.emergentagent.net/job_ccdecd77-3663-49a5-8d28-298a2c8d681f/artifacts/9987c2362ff7d597_2%20main.webp",
  aboutPhoto:
    "https://customer-assets-jai6qajn.emergentagent.net/job_ccdecd77-3663-49a5-8d28-298a2c8d681f/artifacts/bd507ed24fb76ac7_4.jpg",
};

export const SUMMARY =
  "Digital Marketing Specialist with 1+ year of experience in social media management, content strategy, and campaign analytics. Improved audience engagement by 30% and cut workflow turnaround time by 20% through data-driven strategies and process optimization.";

export const METRICS = [
  { value: "+30%", label: "Engagement Growth" },
  { value: "+50%", label: "Instagram Growth" },
  { value: "80+", label: "Videos Produced" },
];

export const PHILOSOPHY = [
  {
    title: "Data-First Intuition",
    body: "Every creative call is backed by KPIs, analytics and audience signals — never guesswork.",
  },
  {
    title: "Brand-Compliant Storytelling",
    body: "Content calendars and brand guidelines that keep every post, reel and video unmistakably on-brand.",
  },
  {
    title: "Relentless Optimisation",
    body: "SEO, thumbnails, hooks and scheduling tuned platform-by-platform until the numbers move.",
  },
];

export const EXPERIENCE = [
  {
    role: "Freelance Video Editor",
    org: "Independent",
    period: "Jan 2026 — Mar 2026",
    points: [
      "Edited 10+ engaging Instagram Reels and short-form videos for a kids' rental toy shop.",
    ],
  },
  {
    role: "Digital Marketing Manager & Strategy Analyst",
    org: "Creafinity",
    period: "Jan 2025 — Dec 2025",
    points: [
      "Managed digital marketing and content strategy for 5+ clients with full brand consistency.",
      "Led a 12-member cross-functional team and mentored 5+ interns.",
      "Owned 80+ video productions end-to-end, from pre-production to post.",
      "Grew YouTube channel performance by 30% and Instagram performance by 50%.",
    ],
  },
  {
    role: "Financial Analysis Intern",
    org: "Phafat & Rathi, Chartered Accountants",
    period: "Aug 2023 — Sep 2023",
    points: [
      "Supported compliance documentation with strong attention to data accuracy.",
      "Built a project report on goat farming operations with financial analysis and cost estimation.",
    ],
  },
];

export const EDUCATION = [
  {
    degree: "MBA — Finance & Marketing",
    org: "Institute of Business Management & Research, Pune",
    period: "2022 — 2024",
    note: "PRO & Fest Committee Member · Leadership in business events",
  },
  {
    degree: "BBA — Business Administration",
    org: "Takshashila Mahavidyalaya, Amravati",
    period: "2018 — 2021",
    note: "Hosted & managed college-level business events",
  },
];

export const ATMABHAN = {
  id: "atmabhan",
  title: "Atmabhan",
  subtitle: "From digital visibility to community & conversion",
  tag: "CASE STUDY · 2026",
  description:
    "A spiritual learning and wellness brand connecting traditional Indian wisdom with modern life. Positioning, audience strategy, YouTube growth, content marketing and lead generation — engineered as one system.",
  tags: ["Brand Positioning", "YouTube Growth", "Lead Gen"],
  metric: "59K+ Subscribers",
  image:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_my-portfolio-1638--0ahqp4ex/artifacts/1ad000a9c66c6e4b_aa%20cover.jpg",
  span: "lg:col-span-7",
  client: { industry: "Spirituality · Wellness · Education", market: "Pune, Maharashtra — pan-India reach" },
  stats: [
    { value: "350", label: "Oct 2024 baseline" },
    { value: "25K+", label: "Jul 2025 milestone" },
    { value: "59K+", label: "Current subscribers" },
    { value: "168.6×", label: "Channel multiplier" },
  ],
  funnel: [
    { stage: "TOFU", title: "Awareness", body: "YouTube Shorts & Reels, spiritual knowledge clips, SEO blogs, podcast snippets." },
    { stage: "MOFU", title: "Consideration", body: "Program explainers, founder-led videos, testimonials, free intro sessions." },
    { stage: "BOFU", title: "Conversion", body: "Workshop registration, course & retreat enquiry, WhatsApp follow-up." },
  ],
  channels: [
    { name: "YouTube", role: "Authority & discovery — long-form education, podcasts, Shorts" },
    { name: "Instagram", role: "Reach & engagement — Reels, carousels, testimonials" },
    { name: "Google", role: "High-intent demand — local SEO, search ads, program pages" },
    { name: "LinkedIn", role: "Corporate partnerships — wellness sessions, HR outreach" },
    { name: "WhatsApp", role: "Lead nurturing — enquiry replies, reminders, follow-ups" },
  ],
  budget: { total: "₹25,000 / month", note: "Meditation ₹10k · Yoga ₹5k · Brand ₹3k · Retreat ₹5k · Retargeting ₹2k" },
  tracking: ["GA4", "Google Tag Manager", "Meta Pixel", "Google Ads", "YouTube Studio"],
  targets: [
    { label: "YouTube subscriber growth", value: "+15%" },
    { label: "Website traffic", value: "+30%" },
    { label: "Qualified leads", value: "100" },
    { label: "Workshop registrations", value: "50" },
    { label: "Instagram reach", value: "+30%" },
  ],
  insight:
    "Convert Atmabhan's growing content audience into trust, registrations and a long-term community.",
};

export const PROJECTS = [
  {
    ...ATMABHAN,
    placeholder: false,
  },
  {
    id: "drab",
    placeholder: false,
    title: "Dr. AB — Paid Media",
    subtitle: "Calm Precision. Confident Movement.",
    tag: "CASE STUDY · PAID MEDIA",
    description:
      "Meta Ads campaign strategy for a robotic joint replacement practice — generating consultation enquiries through reassuring, informative messaging, not fear-based claims.",
    tags: ["Meta Ads", "Lead Gen", "Healthcare"],
    metric: "₹1,500/day Test Budget",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_my-portfolio-1638--0ahqp4ex/artifacts/ff9a6032ab5fc49b_ab%20campaign.jpg",
    span: "lg:col-span-5",
  },
  {
    id: "candle",
    placeholder: false,
    title: "Candle Vandle — SEO Audit",
    subtitle: "Lit Moments, Brighter Days",
    tag: "CASE STUDY · SEO AUDIT",
    description:
      "Full SEO audit for an online candle shop — keyword research, on-page and technical recommendations, keyword-to-page mapping and a 30-day action plan.",
    tags: ["SEO", "E-commerce", "Content"],
    metric: "12 Keywords Mapped",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_my-portfolio-1638--0ahqp4ex/artifacts/857062ffa916222f_candle%20vandle%20web.png",
    span: "lg:col-span-12",
  },
  {
    id: "iggrowth",
    placeholder: false,
    title: "Instagram Growth",
    subtitle: "Three clients, three growth curves",
    tag: "CASE STUDY · SOCIAL GROWTH",
    description:
      "Ten months of Instagram growth across three client accounts — a surgeon, a doctor and a wellness brand — driven by consistent content, platform-native formats and data-led iteration.",
    tags: ["Instagram", "Growth", "Content Strategy"],
    metric: "+2,099% Peak Growth",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_my-portfolio-1638--0ahqp4ex/artifacts/41bac24412493199_ig%20cover.jpg",
    span: "lg:col-span-12",
  },
];

export const MARQUEE_ITEMS = [
  "Performance Marketing",
  "Brand Strategy",
  "Content Calendars",
  "Video Production",
  "Conversion Optimisation",
  "Data Analytics",
];

export const SKILL_CATEGORIES = [
  {
    title: "Social & Content Strategy",
    span: "lg:col-span-7",
    skills: [
      { name: "Content Strategy", level: 92 },
      { name: "Social Media Management", level: 90 },
      { name: "Brand Guidelines", level: 88 },
    ],
    chips: ["Instagram", "Facebook", "YouTube", "Content Calendars"],
  },
  {
    title: "Analytics & MarTech",
    span: "lg:col-span-5",
    skills: [
      { name: "Campaign Analytics", level: 85 },
      { name: "KPI Tracking", level: 86 },
    ],
    chips: ["GA4", "YouTube Studio", "Google Workspace", "MS Office"],
  },
  {
    title: "Paid & Performance",
    span: "lg:col-span-4",
    skills: [{ name: "Paid Campaigns", level: 78 }],
    chips: ["Google Ads", "Meta Ads", "Campaign Planning"],
  },
  {
    title: "Creative & Production",
    span: "lg:col-span-4",
    skills: [{ name: "Video Production & Editing", level: 88 }],
    chips: ["Premiere Pro", "Canva", "Reels & Shorts", "Thumbnails"],
  },
  {
    title: "Leadership & AI",
    span: "lg:col-span-4",
    skills: [{ name: "Team Leadership", level: 90 }],
    chips: ["12-Member Team", "Mentoring", "Claude", "AI Workflows"],
  },
];

export const DRAB = {
  objective:
    "Generate relevant consultation enquiries for robotic joint replacement surgery through Facebook and Instagram.",
  concept: "Calm Precision. Confident Movement.",
  budget: { total: "₹1,500 / day", note: "Awareness ₹300 · Lead Gen ₹900 · Retargeting ₹300" },
  positioning: [
    { title: "Planning", body: "Emphasise careful evaluation and procedure planning." },
    { title: "Precision", body: "Communicate a considered surgical approach and appropriate use of technology." },
    { title: "Controlled Execution", body: "Show a calm, professional clinical environment and coordinated team." },
    { title: "Structured Recovery", body: "Highlight personalised recovery guidance and follow-up." },
  ],
  structure: [
    { stage: "Awareness", role: "Build familiarity with Dr. AB and the care approach.", share: "20% · ₹300/day" },
    { stage: "Lead Generation", role: "Drive consultation enquiries through WhatsApp, calls or website form.", share: "60% · ₹900/day" },
    { stage: "Retargeting", role: "Reconnect with eligible people who engaged with content or the website.", share: "20% · ₹300/day" },
  ],
  ads: [
    { angle: "Trust & Authority", message: "The best joint replacement surgeries don't look dramatic.", cta: "Book Consultation" },
    { angle: "Lifestyle & Relevance", message: "Your world shouldn't revolve around knee pain.", cta: "Explore Options" },
    { angle: "Doctor Authority", message: "Every surgical journey starts with the right plan.", cta: "Schedule Consultation" },
    { angle: "Technology & Precision", message: "Technology meets surgical precision.", cta: "Know More" },
  ],
  audience: [
    "Location: clinic catchment area; city and radius to be confirmed",
    "Age 40–65+, all genders",
    "English, Hindi & Marathi",
    "Broad local targeting; refine on enquiry quality",
    "Advantage+ placements, creative adapted per format",
  ],
  measurement: [
    { label: "CTR & CPC", note: "Creative engagement and traffic efficiency" },
    { label: "CPL", note: "Cost per enquiry" },
    { label: "Qualified Enquiries", note: "Leads matching clinic service criteria" },
    { label: "Booked Consultations", note: "Enquiries converted into appointments" },
    { label: "Show-up Rate", note: "Booked appointments attended" },
    { label: "Cost per Attended Consultation", note: "Downstream campaign efficiency" },
  ],
  success: "Qualified enquiries and booked consultations — not clicks alone.",
  mockup:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_my-portfolio-1638--0ahqp4ex/artifacts/594f7942f71471d8_Dr.%20AB%20Surgical%20Campaign%20Mockups.png",
};

export const CANDLE = {
  tagline: "Lit Moments, Brighter Days",
  website: "https://penny-carry-67751650.figma.site/",
  scope:
    "Public-facing website review and strategic recommendations across keyword targeting, on-page SEO, technical foundations, content and UX.",
  findings: [
    { param: "Page title & metadata", note: "Verify unique title and meta description; include relevant product and gifting terms.", priority: "High" },
    { param: "Keyword targeting", note: "Build separate targets for product, gifting, party and home-fragrance searches.", priority: "High" },
    { param: "Headings & content", note: "Validate one clear H1, logical H2/H3 hierarchy and useful category copy.", priority: "High" },
    { param: "Images & alt text", note: "Use descriptive, relevant alt text for product and lifestyle images.", priority: "Medium" },
    { param: "Mobile & performance", note: "Test responsive layouts, loading performance and Core Web Vitals.", priority: "High" },
    { param: "Indexing & sitemap", note: "Verify indexability, robots directives, XML sitemap and Search Console status.", priority: "High" },
    { param: "Analytics & tracking", note: "Confirm GA4 and conversion events for product views, add-to-cart and purchases.", priority: "Medium" },
  ],
  keywords: [
    { kw: "Buy candles online", intent: "Transactional", priority: "High" },
    { kw: "Scented candles online", intent: "Transactional", priority: "High" },
    { kw: "Candle gift sets", intent: "Transactional", priority: "High" },
    { kw: "Candles for birthday gifts", intent: "Transactional", priority: "High" },
    { kw: "Luxury candles for gifting", intent: "Transactional", priority: "High" },
    { kw: "Affordable candles online", intent: "Transactional", priority: "High" },
    { kw: "Decorative candles for home", intent: "Commercial", priority: "High" },
    { kw: "Party decoration candles", intent: "Commercial", priority: "Medium" },
    { kw: "Wedding return gift candles", intent: "Transactional", priority: "Medium" },
    { kw: "Handmade candles online", intent: "Transactional", priority: "Medium" },
    { kw: "Personalised candles", intent: "Transactional", priority: "Medium" },
    { kw: "Aromatic candles for bedroom", intent: "Commercial", priority: "Medium" },
  ],
  mapping: [
    { search: "Buy / affordable candles online", dest: "Shop or main product collection" },
    { search: "Birthday candle gifts / luxury gift sets", dest: "Birthday gifting or gift sets collection" },
    { search: "Party decoration candles", dest: "Party and celebration collection" },
    { search: "Wedding return gifts / personalised", dest: "Wedding favours and custom orders page" },
    { search: "Scented / aromatic bedroom candles", dest: "Scented candles category or product pages" },
    { search: "Decorative candles for home", dest: "Home décor candle collection" },
  ],
  onpage: {
    title: "Candle Vandle | Scented, Decorative & Gift Candles",
    meta: "Shop scented and decorative candles at Candle Vandle. Explore thoughtful candle gifts for birthdays, celebrations and cosy everyday spaces.",
    h1: "Light Up Your Moments with Beautifully Crafted Candles",
  },
  technical: [
    { item: "Domain", details: "Consider a branded custom domain instead of the default Figma subdomain before launch." },
    { item: "Indexing", details: "Verify Google Search Console ownership, indexability and canonical URLs." },
    { item: "Sitemap", details: "Check XML sitemap availability and submit it to Search Console." },
    { item: "Performance", details: "Test mobile usability, image optimisation and Core Web Vitals." },
    { item: "Structured data", details: "Add eligible Product, Organization and Breadcrumb schema." },
  ],
  plan: [
    { week: "Week 1", actions: "Confirm target keywords; optimise homepage and key page titles, meta descriptions and headings." },
    { week: "Week 2", actions: "Improve product/category copy, image alt text and internal linking." },
    { week: "Week 3", actions: "Validate mobile experience, indexing, sitemap and page performance." },
    { week: "Week 4", actions: "Configure analytics and establish a baseline for organic clicks, impressions and conversions." },
  ],
  conclusion:
    "Candle Vandle can build stronger organic visibility by aligning product and category pages with purchase, gifting, celebration and home-fragrance searches.",
};

export const IG_GROWTH = {
  period: "Jan 2026 — Nov 2026",
  clients: [
    {
      name: "Dr. Abhishek Prem Bhalotia",
      handle: "@dr.abhishekbhalotia",
      role: "Robotic Joint Replacement Surgeon",
      from: "578",
      to: "12.7K",
      growth: "+2,099%",
      insight: "+12.1K new followers in 10 months · 360 total posts",
      image:
        "https://customer-assets-cm19k8pv.emergentagent.net/job_my-portfolio-1638--0ahqp4ex/artifacts/af5823ba45fce5a4_Instagram%20Growth%20Journey%20Dashboard.png",
    },
    {
      name: "Dr. Shraddha Chandak",
      handle: "@dr.shraddhachandak",
      role: "Doctor",
      from: "200",
      to: "1,285",
      growth: "+525%",
      insight: "~109 new followers per month on average · 5× community growth",
      image:
        "https://customer-assets-cm19k8pv.emergentagent.net/job_my-portfolio-1638--0ahqp4ex/artifacts/49147b087d22507c_Dr.%20Shraddha%20Chandak%E2%80%99s%20Instagram%20Growth.png",
    },
    {
      name: "Atmabhan",
      handle: "@atmabhan",
      role: "Dhyaan, Yog & Pranayam · Holistic Wellness",
      from: "8,000",
      to: "15.2K",
      growth: "+88%",
      insight: "+7.2K new followers in 10 months · +298% increase in posts",
      image:
        "https://customer-assets-cm19k8pv.emergentagent.net/job_my-portfolio-1638--0ahqp4ex/artifacts/b65176ddd8eee01f_Atmabhan%20Instagram%20Growth%20Infographic.png",
    },
  ],
};

export const ACHIEVEMENTS = [
  {
    title: "Highest-Viewed Video on the Channel",
    body: "Edited the channel's most-watched video — 1.9 Lakh+ views and counting.",
    stat: "1.9L+",
    statLabel: "Views",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_my-portfolio-1638--0ahqp4ex/artifacts/9a6375049cbf7435_Marathi%20Wisdom%20Thumbnail%20on%20Laptop.png",
    alt: "Highest-viewed video thumbnail — 1.9 Lakh+ views, edited by Aditi",
  },
  {
    title: "Thumbnail Design Portfolio",
    body: "Designed 30+ thumbnails across long-form YouTube videos and Shorts — including 20+ thumbnail designs spanning hooks, typography and platform-native formats.",
    stat: "30+",
    statLabel: "Thumbnails",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_my-portfolio-1638--0ahqp4ex/artifacts/9c2e66d587f54e87_YouTube%20Shorts%20Thumbnail%20Showcase.png",
    alt: "Showcase of YouTube Shorts thumbnails designed by Aditi",
  },
];

export const CERTIFICATIONS = [
  "Digital Marketing — Google",
  "Business Analysis — Analyst Club",
];

export const LANGUAGES = ["English", "Hindi", "Marathi"];
